// Scope: collects validated room details before the server creates the room.

import React, { useState } from "react";
import useChatRoomStore from "../../chatRoomStore.js";
import { v4 as uuidv4 } from "uuid";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

const CreateRoom = ({ socket, chatId }) => {
    const [roomName, setRoomName] = useState("");
    const [roomKey, setRoomKey] = useState("");
    const [error, setError] = useState("");
    const { rooms, setCreateRoom, isPrivateRoom, setIsPrivateRoom } =
        useChatRoomStore();

    const reset = () => {
        setCreateRoom(false);
        setRoomName("");
        setRoomKey("");
        setError("");
        setIsPrivateRoom(false);
    };

    const handleCreateRoom = (event) => {
        event.preventDefault();
        const trimmedRoomName = roomName.trim();

        if (trimmedRoomName.length < 3 || trimmedRoomName.length > 40) {
            setError("Room names must be between 3 and 40 characters.");
            return;
        }

        if (rooms.some((room) => room.name.toLowerCase() === trimmedRoomName.toLowerCase())) {
            setError("A room with that name already exists.");
            return;
        }

        if (isPrivateRoom && (roomKey.trim().length < 4 || roomKey.trim().length > 64)) {
            setError("Private-room passwords must be between 4 and 64 characters.");
            return;
        }

        const roomId = uuidv4();

        // Assuming you have a function to generate unique room IDs
        const newRoom = {
            id: roomId,
            name: trimmedRoomName,
            hostId: chatId,
            isPrivate: isPrivateRoom ? true : false,
            roomKey: isPrivateRoom ? roomKey.trim() : null,
        };

        reset();
        socket.emit("updateRoom", newRoom);
    };

    return (
        <form className="create-room-box" onSubmit={handleCreateRoom}>
            <h2>Create a new room</h2>
            {error && <p className="chat-form-error" role="alert">{error}</p>}
            <label className="room-name-label" htmlFor="roomName">
                Room name
                <input
                    className="room-name-input"
                    type="text"
                    id="roomName"
                    value={roomName}
                    maxLength={40}
                    autoFocus
                    onChange={(e) => {
                        setRoomName(e.target.value);
                        setError("");
                    }}
                />
            </label>

            {isPrivateRoom && (
                <div>
                    <label className="room-key-label" htmlFor="roomKey">
                        Room password
                        <input
                            className="room-key-input"
                            type="password"
                            id="roomKey"
                            value={roomKey}
                            minLength={4}
                            maxLength={64}
                            autoComplete="new-password"
                            onChange={(e) => {
                                setRoomKey(e.target.value);
                                setError("");
                            }}
                        />
                    </label>
                </div>
            )}
            <button className="create-room-btn" type="submit" disabled={!socket || !chatId}>
                Create Room
            </button>
            <button
                type="button"
                aria-label="Cancel room creation"
                className="create-room-cancel-btn"
                onClick={reset}
            >
                <CancelOutlinedIcon aria-hidden="true" />
            </button>
        </form>
    );
};

export default CreateRoom;
